import { defineSectionEvents } from '../utils';

/**
 * App-chrome interactions that don't belong to a single feature tab: the left
 * sidebar (menu item navigation + collapse chevron) and global appearance
 * preferences (dark mode).
 */
export const NAVIGATION_EVENTS = {
  ...defineSectionEvents('Navigation', 'Sidebar', {
    NAVIGATION_MENU_ITEM_SELECTED: {
      action: 'Menu Item Selected',
      description:
        'User clicked an item in the left sidebar navigation (Dashboard, ' +
        'Sales Pipeline, Agency, Invitations, Contacts, Tools, Reports, ' +
        'Benchmark, etc.). The specific item is sent as a property.',
      properties: {
        item: {
          type: 'string',
          description:
            'Translation key of the selected menu item (e.g. "FTR_DASHBOARD").',
        },
        group: {
          type: 'string',
          description:
            'Translation key of the sidebar section the item belongs to.',
        },
        url: {
          type: 'string',
          description: 'Route the item navigates to (e.g. "dashboard").',
        },
      },
    },

    NAVIGATION_MENU_COLLAPSE_TOGGLED: {
      action: 'Menu Collapse Toggled',
      description:
        'User clicked the chevron to collapse or expand the left sidebar.',
      properties: {
        collapsed: {
          type: 'boolean',
          description: 'New state after the toggle (true = collapsed).',
        },
      },
    },
  }),

  ...defineSectionEvents('Navigation', 'Appearance', {
    NAVIGATION_DARK_MODE_TOGGLED: {
      action: 'Dark Mode Toggled',
      description: 'User toggled the dark-mode switch in the avatar menu.',
      properties: {
        theme: {
          type: 'string',
          description: 'Theme selected after the toggle ("dark" or "light").',
        },
      },
    },
  }),
};
